module.exports = __webpack_public_path__ + "static/media/STPLong2w522@1x.ac79c12b.webp";